import flatpickr from 'flatpickr';

const today = new Date();

const endDates = flatpickr('.enddate', {
  locale: 'nl',
  altInput: true,
  altFormat: 'j F Y',
});

flatpickr('.startdate', {
  locale: 'nl',
  altInput: true,
  altFormat: 'j F Y',
  minDate: today,
  onChange(selectedDates, dateStr) {
    const nextDay = new Date(dateStr);

    endDates.forEach((endDate) => {
      endDate.minDate = nextDay.setDate(nextDay.getDate() + 1);
    });
  },
});
